import _ from 'lodash';
import moment from 'moment';
import {GRAPH_FORMAT_MOMENT} from '../utils/time_utils';
import * as ActionTypes from './actionTypes';

export const KEY_PREFIX = 'ManualData_';

function _stillRelevant(feature, delete_if_before) {
  const data = feature.properties.data;
  const keys = _.keys(data);
  if (0 === keys.length) {
    return false;
  }

  const latestChange = _.max(keys.map(k => moment(k, GRAPH_FORMAT_MOMENT)));
  return latestChange.isAfter(delete_if_before);
}

export const populateManualWeatherAsync = () => {
  const delete_if_before = moment().subtract(3, 'days');
  return dispatch => {
    const features = {};

    const len = localStorage.length;
    const keys = [];
    for (let i = 0; i < len; ++i) {
      const key = localStorage.key(i);
      if (key.match(`^${KEY_PREFIX}`)) {
        keys.push(key);
      }
    }

    keys.forEach((key) => {
      const feature = JSON.parse(localStorage.getItem(key));
      if (_stillRelevant(feature, delete_if_before)) {
        features[feature.properties.key] = feature;
      } else {
        localStorage.removeItem(key);
      }
    });

    dispatch({ type: ActionTypes.POPULATE_MANUAL_WEATHER_DATA, features });
  };
};



// WEBPACK FOOTER //
// ./src/actions/populate_manual_weather.js